<template>
    <div class="section section_video">
        <div class="bk bk_video-block" data-aos="fade-up"></div>
        <div class="container">
            <div class="quote" data-aos="fade-up">
                <div class="quote__title" v-html="model.quote"></div>
            </div>
        </div>
        <div class="link_video" data-aos="fade-up">
            <img src="@/assets/img/video_preview2.jpg" alt="video">
            <div class="link_video__btn" @click="modalVideo = true">
                <img src="@/assets/svg/play.svg" alt="play">
            </div>
            <div v-show="!$store.state.edit" class="video__title">{{ model.video_title }}</div>
        </div>
        <div class="container" data-aos="fade-up"></div>
        <transition name="modal">
            <div class="modal"
                 v-if="modalVideo">
                <button class="close_modal"
                        @click="modalVideo = false">
                    <img src="@/assets/svg/icon_close_b.svg" alt="icon_close_b">
                </button>
                <div class="modal__window modal__window_video">
                    <iframe width="800" height="460" :src="model.video_link"
                            frameborder="2"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>

    export default {
        props: ['model'],
        data() {
            return {
                modalVideo: false,
            }
        },
    }

</script>

<style lang="scss" scoped>

    .section_video {
        @media screen and (max-width: 1024px) {
        }
    }

    /* стили окна видео */

    .link_video {
        position: relative;
        width: 50%;
        max-width: 90vh;
        margin: 60px auto 15px auto;
        cursor: pointer;
        @media screen and (max-width: 1400px) {
            width: 70vh;
        }
        @media screen and (max-width: 1024px) {
            margin-top: 80px;
            width: 100%;
        }
    }

    .link_video img {
        width: 100%;
    }

    .link_video__btn {
        position: absolute;
        top: 0;
        padding-bottom: 23%;
        padding-top: 23%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        @media screen and (max-width: 800px) {
            padding-top: 16%;
            padding-bottom: 16%;
        }
    }

    .link_video__btn img {
        height: 80px;
        transition: all ease-in-out .6s;
    }

    .link_video__btn:hover img {
        opacity: .66;
        transform: scale(1.3);
    }

    .video__title {
        position: relative;
        font-family: 'CirceLight', sans-serif;
        font-size: 20pt;
        margin-top: 20px;
        line-height: 1.3;
        @media screen and (max-width: 1024px) {
            margin-left: 10%;
        }
    }

    /* стили цитаты */

    .quote {
        width: 45%;
        padding-top: 73px;
        @media screen and (max-width: 1024px) {
            width: 80%;
            padding-top: 40px;
        }
        @media screen and (max-width: 500px) {
            width: 90%;
            padding-top: 20px;
        }
    }

    .quote__title {
        font-family: "CirceBold", sans-serif;
        font-size: 36px;
        line-height: 1.3;
        margin-bottom: 20px;
        @media screen and (max-width: 1400px) {
            font-size: 30px;
        }
        @media screen and (max-width: 1024px) {
            font-size: 26px;
        }
    }

    .quote__author {
        font-family: "CirceBold", sans-serif;
        font-size: 24px;
        text-align: right;
    }

    /* стили 'background-a' */

    .bk_video-block {
        position: absolute;
        width: 38%;
        right: 0;
        top: 0;
        height: 108%;
        background-image: url('../../assets/img/MA_1920_beton1.png');
        background-repeat: no-repeat;
        @media screen and (max-width: 1024px) {
            width: 100%;
            margin-top: 270px;
            height: 90%;
            display: none;
        }
        @media screen and (max-width: 800px) {
            width: 100%;
            margin-top: 270px;
            height: 120%;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/home-page-components/VideoBlock.vue